import { configureStore } from '@reduxjs/toolkit';
import alertReducer from './redux/alertSlice';
import quotationReducer from './redux/quotationSlice';
import searchReducer from './redux/searchSlice';

export const store = configureStore({
  reducer: {
    alert: alertReducer,
    search: searchReducer,
    quotation: quotationReducer,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;